import React, { Component } from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

import { name, storageKeys } from 'settings';
import { BackImage, StorageHandler, LanguageSelect } from 'C4';

import logo from 'assets/images/logo/logo_white.png';


export default class WelcomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
      lastName: '',
      agency: '',
      state: '',
    };
  }

  componentWillMount() {
    StorageHandler.load(storageKeys.user).then((res) => {
      this.setState({
        firstName: res.response.first_name,
        lastName: res.response.last_name,
        agency: res.response.agency_name,
        state: res.response.state,
      });
    });
  }

  render() {
    const {
      agency,
      state,
      firstName,
      lastName,
    } = this.state;

    return (
      <div className="welcomeView">
        <BackImage />
        <div className="welcomeView__Wrapper">
          <div className="welcomeView__left">
            <div className="welcomeView__left--top">
              <img src={logo} alt={name} />
            </div>
            <div className="welcomeView__left--bottom">
              <h1>{i18n.translate('welcomeScreen.hello')}</h1>
              <h1>{`${firstName} ${lastName}`}</h1>
              <h6>{`${agency} ${state}`}</h6>
              <LanguageSelect />
            </div>
          </div>
          <div className="welcomeView__right">
            <div className="welcomeView__right--top">
              {/* TODO: Personalized content here at customer request */}
            </div>
            <div className="welcomeView__right--bottom">
              <Link to="/logout">
                <button
                  type="button"
                  className="btnInverse"
                >{i18n.translate('welcomeScreen.notUser'), `Not ${firstName} ${lastName}?`}
                  {/* {`Not ${firstName} ${lastName}?`} */}
                </button>
              </Link>
              <Link to="/main/training">
                <button type="button">{i18n.translate('welcomeScreen.startTraining')}</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
